export interface RouteParams {
    scheduleId: string;
}

export const timeZoneOptions = [
    { value: 'Africa/Bangui', label: 'Africa/Bangui' },
    { value: 'Africa/Cairo', label: 'Africa/Cairo' },
    { value: 'Africa/Casablanca', label: 'Africa/Casablanca' },
    { value: 'Africa/Harare', label: 'Africa/Harare' },
    { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg' },
    { value: 'Africa/Lagos', label: 'Africa/Lagos' },
    { value: 'Africa/Monrovia', label: 'Africa/Monrovia' },
    { value: 'Africa/Nairobi', label: 'Africa/Nairobi' },
    { value: 'Africa/Windhoek', label: 'Africa/Windhoek' },
    { value: 'America/Anchorage', label: 'America/Anchorage' },
    { value: 'America/Argentina/San_Juan', label: 'America/Argentina/San_Juan' },
    { value: 'America/Asuncion', label: 'America/Asuncion' },
    { value: 'America/Bahia', label: 'America/Bahia' },
    { value: 'America/Bogota', label: 'America/Bogota' },
    { value: 'America/Buenos_Aires', label: 'America/Buenos_Aires' },
    { value: 'America/Caracas', label: 'America/Caracas' },
    { value: 'America/Cayenne', label: 'America/Cayenne' },
    { value: 'America/Chicago', label: 'America/Chicago' },
    { value: 'America/Chihuahua', label: 'America/Chihuahua' },
    { value: 'America/Cuiaba', label: 'America/Cuiaba' },
    { value: 'America/Denver', label: 'America/Denver' },
    { value: 'America/Fortaleza', label: 'America/Fortaleza' },
    { value: 'America/Godthab', label: 'America/Godthab' },
    { value: 'America/Guatemala', label: 'America/Guatemala' },
    { value: 'America/Halifax', label: 'America/Halifax' },
    { value: 'America/Indianapolis', label: 'America/Indianapolis' },
    { value: 'America/Indiana/Indianapolis', label: 'America/Indiana/Indianapolis' },
    { value: 'America/La_Paz', label: 'America/La_Paz' },
    { value: 'America/Los_Angeles', label: 'America/Los_Angeles' },
    { value: 'America/Mexico_City', label: 'America/Mexico_City' },
    { value: 'America/Montevideo', label: 'America/Montevideo' },
    { value: 'America/New_York', label: 'America/New_York' },
    { value: 'America/Noronha', label: 'America/Noronha' },
    { value: 'America/Phoenix', label: 'America/Phoenix' },
    { value: 'America/Regina', label: 'America/Regina' },
    { value: 'America/Santa_Isabel', label: 'America/Santa_Isabel' },
    { value: 'America/Santiago', label: 'America/Santiago' },
    { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo' },
    { value: 'America/St_Johns', label: 'America/St_Johns' },
    { value: 'America/Tijuana', label: 'America/Tijuana' },
    { value: 'Antarctica/McMurdo', label: 'Antarctica/McMurdo' },
    { value: 'Atlantic/South_Georgia', label: 'Atlantic/South_Georgia' },
    { value: 'Asia/Almaty', label: 'Asia/Almaty' },
    { value: 'Asia/Amman', label: 'Asia/Amman' },
    { value: 'Asia/Baghdad', label: 'Asia/Baghdad' },
    { value: 'Asia/Baku', label: 'Asia/Baku' },
    { value: 'Asia/Bangkok', label: 'Asia/Bangkok' },
    { value: 'Asia/Beirut', label: 'Asia/Beirut' },
    { value: 'Asia/Calcutta', label: 'Asia/Calcutta' },
    { value: 'Asia/Colombo', label: 'Asia/Colombo' },
    { value: 'Asia/Damascus', label: 'Asia/Damascus' },
    { value: 'Asia/Dhaka', label: 'Asia/Dhaka' },
    { value: 'Asia/Dubai', label: 'Asia/Dubai' },
    { value: 'Asia/Irkutsk', label: 'Asia/Irkutsk' },
    { value: 'Asia/Jerusalem', label: 'Asia/Jerusalem' },
    { value: 'Asia/Kabul', label: 'Asia/Kabul' },
    { value: 'Asia/Kamchatka', label: 'Asia/Kamchatka' },
    { value: 'Asia/Karachi', label: 'Asia/Karachi' },
    { value: 'Asia/Katmandu', label: 'Asia/Katmandu' },
    { value: 'Asia/Kolkata', label: 'Asia/Kolkata' },
    { value: 'Asia/Krasnoyarsk', label: 'Asia/Krasnoyarsk' },
    { value: 'Asia/Kuala_Lumpur', label: 'Asia/Kuala_Lumpur' },
    { value: 'Asia/Kuwait', label: 'Asia/Kuwait' },
    { value: 'Asia/Magadan', label: 'Asia/Magadan' },
    { value: 'Asia/Muscat', label: 'Asia/Muscat' },
    { value: 'Asia/Novosibirsk', label: 'Asia/Novosibirsk' },
    { value: 'Asia/Oral', label: 'Asia/Oral' },
    { value: 'Asia/Rangoon', label: 'Asia/Rangoon' },
    { value: 'Asia/Riyadh', label: 'Asia/Riyadh' },
    { value: 'Asia/Seoul', label: 'Asia/Seoul' },
    { value: 'Asia/Shanghai', label: 'Asia/Shanghai' },
    { value: 'Asia/Singapore', label: 'Asia/Singapore' },
    { value: 'Asia/Taipei', label: 'Asia/Taipei' },
    { value: 'Asia/Tashkent', label: 'Asia/Tashkent' },
    { value: 'Asia/Tbilisi', label: 'Asia/Tbilisi' },
    { value: 'Asia/Tehran', label: 'Asia/Tehran' },
    { value: 'Asia/Tokyo', label: 'Asia/Tokyo' },
    { value: 'Asia/Ulaanbaatar', label: 'Asia/Ulaanbaatar' },
    { value: 'Asia/Vladivostok', label: 'Asia/Vladivostok' },
    { value: 'Asia/Yakutsk', label: 'Asia/Yakutsk' },
    { value: 'Asia/Yekaterinburg', label: 'Asia/Yekaterinburg' },
    { value: 'Asia/Yerevan', label: 'Asia/Yerevan' },
    { value: 'Atlantic/Azores', label: 'Atlantic/Azores' },
    { value: 'Atlantic/Cape_Verde', label: 'Atlantic/Cape_Verde' },
    { value: 'Atlantic/Reykjavik', label: 'Atlantic/Reykjavik' },
    { value: 'Australia/Adelaide', label: 'Australia/Adelaide' },
    { value: 'Australia/Brisbane', label: 'Australia/Brisbane' },
    { value: 'Australia/Darwin', label: 'Australia/Darwin' },
    { value: 'Australia/Hobart', label: 'Australia/Hobart' },
    { value: 'Australia/Perth', label: 'Australia/Perth' },
    { value: 'Australia/Sydney', label: 'Australia/Sydney' },
    { value: 'Etc/GMT', label: 'Etc/GMT' },
    { value: 'Etc/GMT+11', label: 'Etc/GMT+11' },
    { value: 'Etc/GMT+12', label: 'Etc/GMT+12' },
    { value: 'Etc/GMT+2', label: 'Etc/GMT+2' },
    { value: 'Etc/GMT-12', label: 'Etc/GMT-12' },
    { value: 'Europe/Amsterdam', label: 'Europe/Amsterdam' },
    { value: 'Europe/Athens', label: 'Europe/Athens' },
    { value: 'Europe/Belgrade', label: 'Europe/Belgrade' },
    { value: 'Europe/Berlin', label: 'Europe/Berlin' },
    { value: 'Europe/Brussels', label: 'Europe/Brussels' },
    { value: 'Europe/Budapest', label: 'Europe/Budapest' },
    { value: 'Europe/Dublin', label: 'Europe/Dublin' },
    { value: 'Europe/Helsinki', label: 'Europe/Helsinki' },
    { value: 'Europe/Istanbul', label: 'Europe/Istanbul' },
    { value: 'Europe/Kiev', label: 'Europe/Kiev' },
    { value: 'Europe/London', label: 'Europe/London' },
    { value: 'Europe/Minsk', label: 'Europe/Minsk' },
    { value: 'Europe/Moscow', label: 'Europe/Moscow' },
    { value: 'Europe/Paris', label: 'Europe/Paris' },
    { value: 'Europe/Sarajevo', label: 'Europe/Sarajevo' },
    { value: 'Europe/Warsaw', label: 'Europe/Warsaw' },
    { value: 'Indian/Mauritius', label: 'Indian/Mauritius' },
    { value: 'Pacific/Apia', label: 'Pacific/Apia' },
    { value: 'Pacific/Auckland', label: 'Pacific/Auckland' },
    { value: 'Pacific/Fiji', label: 'Pacific/Fiji' },
    { value: 'Pacific/Guadalcanal', label: 'Pacific/Guadalcanal' },
    { value: 'Pacific/Guam', label: 'Pacific/Guam' },
    { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu' },
    { value: 'Pacific/Pago_Pago', label: 'Pacific/Pago_Pago' },
    { value: 'Pacific/Port_Moresby', label: 'Pacific/Port_Moresby' },
    { value: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu' },
];
